import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import axios from "axios";
import { env as environment } from "../controllers/environment";
import { useContext } from "react";
import { Context } from "../context";
import { RotatingLines } from "react-loader-spinner";
import Sidebar from "./Sidebar";
import ls from "localstorage-slim";

ls.config.encrypt = true;

const Home = (props) => {
	const { data, setData, inputEmail, setInputEmail, setButtonStatus, prevPage } = useContext(Context);
	const [newEmail, setNewEmail] = useState("");
	const [displayEmail, setDisplayEmail] = useState("");
	const [spinner1, setSpinner1] = useState(false);
	const [spinner2, setSpinner2] = useState(false);
	const [emailValidation, setEmailValidation] = useState(true);
	const [emailValidation2, setEmailValidation2] = useState(true);
	const [existingEmail, setExistingEmail] = useState("");
	const [headingHght, setHeadingHght] = useState(null);
	const navigate = useNavigate();
	useEffect(() => {
		if (prevPage !== "/buttons") {
			setButtonStatus();
			console.log("inputEmail:Home22", inputEmail);
			console.log("CLEAN============");
			setData({});
			setInputEmail();
			localStorage.clear();
			ls.clear();
		}
	}, []); //eslint-disable-line

	//======= New Verification ==========
	const handlesubmitNew = async (e) => {
		e.preventDefault();
		console.log("form", e);
		if (
			//eslint-disable-next-line
			/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
				newEmail
			)
		) {
			setSpinner1(true);
			const json = { email: newEmail, apikey: environment.apikey };
			await axios.post(environment.verifynew, json).then((res) => {
				console.log("handleSubmitNew::RES::", res.data);
				setData(res?.data);
				setInputEmail(newEmail);
				ls.set("inputEmail", newEmail);
				setButtonStatus(res?.data?.data);
				ls.set("buttonstatus", JSON.stringify(res?.data?.data));
				console.log("daata::afterhandlenew::", data);
				// if (res?.data?.email_exists) {
				// 	navigate("/confirmation");
				// } else {
				navigate("/buttons/" + newEmail);
				// }
			});
		} else {
			setEmailValidation(false);
			setTimeout(() => {
				setEmailValidation(true);
			}, 5000);
		}
	};

	//======= Continue Verification ==========
	const handlesubmitContinue = async (e) => {
		e.preventDefault();
		if (
			//eslint-disable-next-line
			/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
				existingEmail
			)
		) {
			setSpinner2(true);
			const json = { email: existingEmail, apikey: environment.apikey };
			await axios.post(environment.verifycontinue, json).then((res) => {
				console.log("handleContinue::RES::", res?.data);
				setData(res?.data);
				setInputEmail(existingEmail);
				ls.set("inputEmail", existingEmail);
				setButtonStatus(res?.data?.data);
				ls.set("buttonstatus", JSON.stringify(res?.data?.data));
				console.log("data::afterContinue", data);
				if (res?.data?.email_exists) {
					navigate("/buttons/" + existingEmail);
				} else {
					navigate("/notfound");
				}
			});
		} else {
			setEmailValidation2(false);
			setTimeout(() => {
				setEmailValidation2(true);
			}, 5000);
		}
	};
	const handleNewEmail = (e) => {
	console.log(e.target.value,"cbre email without lowerCase ")
	const typedEmail = e.target.value;
    const lowercaseEmail = typedEmail.toLowerCase(); 
    setNewEmail(lowercaseEmail); 
    setDisplayEmail(typedEmail); // Store email as typed
	};
	// const handleExistingEmail = (e) => {
	// 	setExistingEmail(e?.target?.value);
	// };
	return (
		<div className="parent">
			{/* <Header /> */}
			{/* <img className="main-logo" src={Logo} alt="cbre logo" /> */}
			<div className="main-container home-container">
				<Sidebar noicons={true} setHeadingHght={setHeadingHght} />
				<div className="middle_home_ui">
					<div className="middle_home_ui_inner">
						<div className="input_files_wra">
							<div className="container-left">
								<form className="input-form home-input" style={{ marginTop: headingHght ? headingHght + "px" : "" }} onSubmit={handlesubmitNew}>
									<input
										className="input-box"
										type="text"
										// required
										placeholder="Email"
										value={displayEmail}
										// pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
										onChange={handleNewEmail}
									/>
									{!emailValidation ? <span className="invalid-email-text">Please enter a valid email</span> : ""}
									{/* <span className="smallItalic">(use existing email to continue with previous verification)</span> */}
									{/* <button className="input-btn" value="Go" ><button/> */}
									<button type="submit" className="input-btn">
										{spinner1 ? <RotatingLines strokeColor="white" strokeWidth="4" animationDuration="0.75" width="25" visible={true} /> : " Go "}
									</button>
								</form>
							</div>
							{/* <div className="container-middle"></div> */}
							<div className="container-right">
								<p className="initiate_verify">
									Please enter your email to start or continue a verification.
								</p>
							</div>
							{/* <div className="container-right">
								<span className="font-green">Continue</span> with verification
								<br />
								(see status page)
								<form className="input-form" onSubmit={handlesubmitContinue}>
									<input
										className="input-box"
										type="text"
										placeholder="Email used earlier"
										required
										value={existingEmail}
										// pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
										onChange={handleExistingEmail}
									/>
									{!emailValidation2 ? <span className="invalid-email-text">Please enter a valid email</span> : ""}
									<button type="submit" className="input-btn">
										{spinner2 ? <RotatingLines strokeColor="white" strokeWidth="4" animationDuration="0.75" width="25" visible={true} /> : " Go "}
									</button>
								</form>
							</div> */}
							{/* <a className="diro-img-container" href="https://diro.io" target="_blank" rel="noreferrer">
								Powered by
								<img class="diro-img" src={DiroLogo} alt="powered by diro" />
							</a> */}
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</div>
	);
};

export default Home;
